import React from "react";
import { localize } from "redux-i18n";
import { ChartJS, View } from "@components";

type Props = $Exact<{
  charts: [],
}>;

export class SlaPerformanceChart extends React.Component<Props> {
  render() {
    return (
      <div className="department-details-report-table w-100">
        {this.props.charts.length < 1 ? (
          <div className={"center-aligned-text"}>
            <h3>{this.props.t("NO_DATA_PLEASE_APPLY_FILTERS")}</h3>
          </div>
        ) : (
          <View className="gs-container">
            <ChartJS
              type="line"
              data={{
                labels: this.props.charts.map(i => i.month),
                datasets: [
                  {
                    label: this.props.t("SLA_PERFORMANCE"),
                    data: this.props.charts.map(i => parseFloat(i.asapCallbacksSlaPercentage)),
                  },
                  {
                    label: this.props.t("SCHEDULED_CALLBACKS_SLA_PERCENTAGE"),
                    data: this.props.charts.map(i => parseFloat(i.scheduledCallbacksSlaPercentage)),
                  },
                  {
                    label: this.props.t("NOTIFICATIONS_SLA_PERCENTAGE"),
                    data: this.props.charts.map(i => parseFloat(i.notificationsSlaPercentage)),
                  },
                ],
              }}
              options={{ height: 300 }}
            />
          </View>
        )}
      </div>
    );
  }
}

export default localize()(SlaPerformanceChart);
